import { useAppContext } from '../../App.context';
import { useMemo } from 'react';

const useMappedSegments = (countryId: number) => {
    const { common } = useAppContext();

    return useMemo(() => {
        const mapping: Record<number, string> = {};

        for (const segment of common?.segments?.[countryId] || []) {
            if (segment.name && segment.id) {
                mapping[segment.id] = segment.name;
            }
        }

        return mapping;
    }, [common?.segments, countryId]);
}

export default useMappedSegments;